import React, { Component } from "react";
import styled from "styled-components";
import Panel from "../common/Panel";
import List from "./ListWithQueryMutation";

export default class LabelPanel extends Component {
  render() {
    return (
      <Panel title="LABEL">
        <Wrapper>
          <List title="CUSTOMER" type="CUSTOMER" />
          <List title="STREAM" type="STREAM" />
          <List title="CASE" type="CASE" />
        </Wrapper>
      </Panel>
    );
  }
}

const Wrapper = styled.div`
  display: flex;
  flex: none;
  flex-direction: row;
  margin-top: 20px;
`;



// WEBPACK FOOTER //
// ./src/module-supervisor-setting/label-panel/LabelPanel.js